import { Component, ViewChild, TemplateRef, ElementRef, AfterViewInit,Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from './services/auth.service';
//import { Idle, DEFAULT_INTERRUPTSOURCES } from '@ng-idle/core';
//import { Keepalive } from '@ng-idle/keepalive';

import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ModalDirective } from 'ngx-bootstrap/modal';
//import { AppService } from './_services/app.service';

import { Subject, Observable } from 'rxjs';

// @Injectable({
//   providedIn: 'root'
// })
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  //title = 'app';
  isLoggedIn$: Observable<boolean>;
  idleState = 'Not started.';
  timedOut = false;
  lastPing?: Date = null;
  title = 'angular-idle-timeout';
  public destroyed$ = new Subject();
  constructor(private authService: AuthService) { }
  ngOnInit()
  {
  //  alert();
    // this.isLoggedIn$ = this.authService.isLoggedIn;
    // if(this.isLoggedIn$)
    // {
    //   this.authService.sessionWarningTimer$.takeUntil(this.destroyed$)
    // }
  }
 ngOnDestroy(){
  this.destroyed$.next();
 }



  //@ViewChild('childModal', { static: false }) childModal: ModalDirective;
 // constructor(private idle: Idle, private keepalive: Keepalive, 
   // private router: Router, private modalService: BsModalService) {
    // sets an idle timeout of 5 seconds, for testing purposes.
    //idle.setIdle(5);
    // sets a timeout period of 5 seconds. after 10 seconds of inactivity, the user will be considered timed out.
   // idle.setTimeout(5);
    // sets the default interrupts, in this case, things like clicks, scrolls, touches to the document
    //idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

    // idle.onIdleEnd.subscribe(() => { 
    //   this.idleState = 'No longer idle.'
    //   console.log(this.idleState);
    //   this.reset();
    // });
    
    // idle.onTimeout.subscribe(() => {
    //   this.idleState = 'Timed out!';
    //   this.timedOut = true;
    //   console.log(this.idleState);
    //   this.router.navigate(['/']);
    // });
    
    // idle.onIdleStart.subscribe(() => {
    //     this.idleState = 'You\'ve gone idle!'
    //     console.log(this.idleState);
    //   //  this.childModal.show();
    // });
    
    // idle.onTimeoutWarning.subscribe((countdown) => {
    //   this.idleState = 'You will time out in ' + countdown + ' seconds!'
    //   console.log(this.idleState);
    // });

    // // sets the ping interval to 15 seconds
    // keepalive.interval(15);

    // keepalive.onPing.subscribe(() => this.lastPing = new Date());

    // this.reset();
  }

  // reset() {
  //   this.idle.watch();
  //   this.idleState = 'Started.';
  //   this.timedOut = false;
  // }


//}



// WEBPACK FOOTER //
// ./src/app/app.component.ts